import MultiSelectField from './MultiSelectField.component';

export default MultiSelectField;